function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import "../../styling/components/import/ImportedContacts.css";
import { Icon } from '@signicat/designi/components/icons';
import { Tooltip } from '@signicat/designi/components/overlays';
import t from "../../scripts/i18n";
import { PhoneNumberUtil } from 'google-libphonenumber';
import { isEqual } from 'lodash';
var phoneUtil = PhoneNumberUtil.getInstance();

var ImportedContacts = function ImportedContacts(props) {
  var contacts = props.contacts,
      onCancel = props.onCancel,
      onSuccess = props.onSuccess;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      contactUnderEdit = _useState2[0],
      setContactUnderEdit = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      tempContacts = _useState4[0],
      setTempContacts = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasErrors = _useState6[0],
      setHasErrors = _useState6[1];

  var handleEdit = function handleEdit(i) {
    return function (e) {
      setContactUnderEdit(contactUnderEdit === i ? null : i);
    };
  };

  var handleDelete = function handleDelete(i) {
    return function (e) {
      setTempContacts(tempContacts.filter(function (x, index) {
        return index !== i;
      }));
      setContactUnderEdit(null);
    };
  };

  var emailValidation = function emailValidation(email) {
    var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  };

  var formatMobile = function formatMobile(value) {
    var parsedVal = value && _typeof(value) === 'object' ? value.prefix + value.number : value;

    if (parsedVal) {
      try {
        var mobileNumber = phoneUtil.parseAndKeepRawInput(parsedVal || '', 'NO');
        var isValid = phoneUtil.isValidNumber(mobileNumber);
        if (isValid) return {
          isValid: isValid,
          value: {
            prefix: "+".concat(mobileNumber.getCountryCode()),
            number: mobileNumber.getNationalNumber().toString()
          }
        };
      } catch (error) {
        return {
          isValid: false
        };
      }
    }

    return {
      isValid: false
    };
  };

  var parsePhone = function parsePhone(index) {
    var value = tempContacts[index].contact.mobileNumber;
    var validationResult = formatMobile(value);

    if (validationResult.isValid) {
      var changedContacts = tempContacts.map(function (x, i) {
        return _objectSpread(_objectSpread({}, x), {}, {
          contact: _objectSpread(_objectSpread({}, x.contact), {}, {
            mobileNumber: index === i ? validationResult.value : x.contact.mobileNumber
          })
        });
      });
      setTempContacts(changedContacts);
    }
  };

  var handleContactChange = function handleContactChange(i, property) {
    return function (e) {
      var value = e.target.value;

      if (value === '') {
        var changedContacts = _toConsumableArray(tempContacts);

        delete changedContacts[i].contact[property];
        setTempContacts(changedContacts);
      } else {
        var _changedContacts = tempContacts.map(function (contactItem, index) {
          return _objectSpread(_objectSpread({}, contactItem), {}, {
            contact: _objectSpread(_objectSpread({}, contactItem.contact), {}, _defineProperty({}, property, index === i ? value : contactItem.contact[property]))
          });
        });

        setTempContacts(_changedContacts);
      }
    };
  };

  var onSave = function onSave() {
    onSuccess(tempContacts.map(function (x) {
      return x.contact;
    }));
  };

  useEffect(function () {
    var newContacts = _toConsumableArray(tempContacts);

    newContacts.forEach(function (_ref, i) {
      var contact = _ref.contact,
          validationResult = _ref.validationResult;

      if (validationResult.isValid) {
        if (!contact.firstName || !contact.lastName || !contact.email && !contact.mobileNumber) {
          newContacts[i].validationResult.isValid = false;
        } else if (contact.email || contact.mobileNumber) {
          var result = true;
          var isEmailValid = emailValidation(contact.email);
          var isMobileValid = formatMobile(contact.mobileNumber).isValid;
          if (contact.email && !isEmailValid || contact.mobileNumber && !isMobileValid) result = false;
          if (!result) newContacts[i].validationResult.isValid = result;
        }
      } else {
        if (contact.firstName && contact.lastName && (contact.email || contact.mobileNumber)) {
          var _result = true;

          var _isEmailValid = emailValidation(contact.email);

          var _isMobileValid = formatMobile(contact.mobileNumber).isValid;
          if (contact.email && !_isEmailValid || contact.mobileNumber && !_isMobileValid) _result = false;
          if (_result) newContacts[i].validationResult.isValid = true;
        }
      }
    });

    if (!isEqual(newContacts, tempContacts)) {
      setTempContacts(newContacts);
    }

    if (newContacts.some(function (_ref2) {
      var validationResult = _ref2.validationResult;
      return !validationResult.isValid;
    })) setHasErrors(true);else setHasErrors(false);
  }, [tempContacts]);
  useEffect(function () {
    // ignore isValid if duplicate
    var tempContacts = contacts.map(function (contact) {
      var isValid = !contact.validationResult.isValid && contact.validationResult.errors.some(function (err) {
        var _err$errorMessage;

        return ((_err$errorMessage = err.errorMessage) === null || _err$errorMessage === void 0 ? void 0 : _err$errorMessage.indexOf('duplicate')) >= 0;
      }) || true;
      return _objectSpread(_objectSpread({}, contact), {}, {
        validationResult: _objectSpread(_objectSpread({}, contact.validationResult), {}, {
          isValid: isValid
        })
      });
    });
    setTempContacts(tempContacts);
  }, [contacts]);
  return /*#__PURE__*/React.createElement("div", {
    className: "imported-contacts"
  }, /*#__PURE__*/React.createElement("table", {
    className: "imported-contacts-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('contact_form_first_name')), /*#__PURE__*/React.createElement("th", null, " ", t('contact_form_last_name')), /*#__PURE__*/React.createElement("th", {
    colSpan: "2"
  }, " ", t('contact_form_email')), /*#__PURE__*/React.createElement("th", null, " ", t('contact_list_phone')), /*#__PURE__*/React.createElement("th", null, " ", t('contact_form_company')), /*#__PURE__*/React.createElement("th", null, " ", t('contact_form_position')), /*#__PURE__*/React.createElement("th", {
    className: "contact-actions"
  }))), /*#__PURE__*/React.createElement("tbody", null, tempContacts.map(function (_ref3, i) {
    var contact = _ref3.contact,
        validationResult = _ref3.validationResult;
    return contactUnderEdit === i ? /*#__PURE__*/React.createElement("tr", {
      key: i,
      className: "row-under-edit ".concat(validationResult.isValid ? '' : 'row-has-error')
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
      className: "input name",
      value: contact.firstName || '',
      onChange: handleContactChange(i, 'firstName')
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
      className: "input name",
      value: contact.lastName || '',
      onChange: handleContactChange(i, 'lastName')
    })), /*#__PURE__*/React.createElement("td", {
      colSpan: "2"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input",
      value: contact.email || '',
      onChange: handleContactChange(i, 'email')
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
      className: "input",
      value: contact.mobileNumber && _typeof(contact.mobileNumber) === 'object' ? contact.mobileNumber.prefix + contact.mobileNumber.number : contact.mobileNumber || '',
      onChange: handleContactChange(i, 'mobileNumber'),
      onBlur: function onBlur() {
        return parsePhone(i);
      }
    })), /*#__PURE__*/React.createElement("td", {
      className: "short-col"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input short-input",
      value: contact.companyName || '',
      onChange: handleContactChange(i, 'companyName')
    })), /*#__PURE__*/React.createElement("td", {
      className: "short-col"
    }, /*#__PURE__*/React.createElement("input", {
      className: "input short-input",
      value: contact.jobTitle || '',
      onChange: handleContactChange(i, 'jobTitle')
    })), /*#__PURE__*/React.createElement("td", {
      className: "contact-actions"
    }, /*#__PURE__*/React.createElement("div", {
      className: "actions-wrapper"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "imported-contacts-table-icon",
      name: "check",
      color: "#6A667D",
      onClick: handleEdit(i)
    }), /*#__PURE__*/React.createElement(Icon, {
      className: "imported-contacts-table-icon",
      name: "close",
      color: "#6A667D",
      onClick: handleDelete(i)
    })))) : /*#__PURE__*/React.createElement("tr", {
      key: i,
      className: "".concat(validationResult.isValid ? '' : 'row-has-error')
    }, contact.firstName ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("td", {
        className: "input name"
      }, contact.firstName),
      arrow: true
    }, contact.firstName) : /*#__PURE__*/React.createElement("td", {
      className: "input name"
    }, contact.firstName || ''), contact.lastName ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("td", {
        className: "input name"
      }, contact.lastName),
      arrow: true
    }, contact.lastName) : /*#__PURE__*/React.createElement("td", {
      className: "input name"
    }, contact.lastName), contact.email ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("td", {
        colSpan: "2",
        className: "input"
      }, contact.email),
      arrow: true
    }, contact.email) : /*#__PURE__*/React.createElement("td", {
      colSpan: "2",
      className: "input"
    }, contact.email), contact.mobileNumber ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("td", {
        className: "input"
      }, contact.mobileNumber && _typeof(contact.mobileNumber) === 'object' ? contact.mobileNumber.prefix + contact.mobileNumber.number : contact.mobileNumber),
      arrow: true
    }, contact.mobileNumber && _typeof(contact.mobileNumber) === 'object' ? contact.mobileNumber.prefix + contact.mobileNumber.number : contact.mobileNumber) : /*#__PURE__*/React.createElement("td", {
      className: "input"
    }, contact.mobileNumber && _typeof(contact.mobileNumber) === 'object' ? contact.mobileNumber.prefix + contact.mobileNumber.number : contact.mobileNumber), contact.companyName ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("td", {
        className: "short-col input short-input"
      }, contact.companyName),
      arrow: true
    }, contact.companyName) : /*#__PURE__*/React.createElement("td", {
      className: "short-col input short-input"
    }, contact.companyName), contact.jobTitle ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("td", {
        className: "short-col input short-input"
      }, contact.jobTitle),
      arrow: true
    }, contact.jobTitle) : /*#__PURE__*/React.createElement("td", {
      className: "short-col input short-input"
    }, contact.jobTitle), /*#__PURE__*/React.createElement("td", {
      className: "contact-actions"
    }, /*#__PURE__*/React.createElement("div", {
      className: "actions-wrapper"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "imported-contacts-table-icon",
      name: "edit",
      color: "#6A667D",
      onClick: handleEdit(i)
    }), /*#__PURE__*/React.createElement(Icon, {
      className: "imported-contacts-table-icon",
      name: "close",
      color: "#6A667D",
      onClick: handleDelete(i)
    }))));
  }))), hasErrors && /*#__PURE__*/React.createElement("div", {
    className: "general-error-message"
  }, /*#__PURE__*/React.createElement("span", null, t('import_contacts_error'), " "), /*#__PURE__*/React.createElement(Icon, {
    name: "warning"
  })), /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onCancel
  }, t('contact_form_cancel')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    disabled: hasErrors,
    onClick: onSave
  }, t('contact_form_save'))));
};

export default ImportedContacts;